import { IModel } from './imodel';
import { DateHelper } from '../utils/date-helper';

export class TimeSlot implements IModel {

    IdObject: any;

    DateTimeFrom: Date;

    DateTimeTo: Date;

    StartMinuteIndex: number;

    EndMinuteIndex: number;

    SlotType: TimeSlotType;

    constructor(dateTimeFrom: Date, dateTimeTo: Date, slotType?: TimeSlotType, objectId?: number) {
        this.DateTimeFrom = dateTimeFrom;
        this.DateTimeTo = dateTimeTo;
        this.StartMinuteIndex = DateHelper.getMinutesOfDay(dateTimeFrom);
        this.EndMinuteIndex = DateHelper.getMinutesOfDay(dateTimeTo);

        if (slotType !== null && slotType !== undefined) {
            this.SlotType = slotType;
        }

        if (objectId) { this.IdObject = objectId; }
    }

    static create(object: TimeSlot, slotType?: TimeSlotType): TimeSlot {
        const ts = new TimeSlot(
            DateHelper.parseDateString(object.DateTimeFrom),
            DateHelper.parseDateString(object.DateTimeTo),
            slotType
        );
        ts.IdObject = object.IdObject;

        return ts;
    }

}

export enum TimeSlotType {
    Closed = -1,
    Vacant = 0,
    Occupied = 1
}
